<template>
  <div class="main-box main-min-height">
    <div class="table-box bgffffff">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="5">
              <el-form-item prop="date" label="下单时间">
                <DateTime v-model="searchForm.date" format='yyyy-MM-dd HH' style="width:100%;height:27px" type='datetimerange' placeholder="-请选择-" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="outTradeNo" label="退款单号">
                <el-input v-model="searchForm.outTradeNo" placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="commodityName" label="订单来源">
                <el-input placeholder="-请输入-" style="width:100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
                <el-button type="primary" @click="exportFile">
                  导出
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="operation_box marginB10">
      </div>
      <div class="table">
        <div class="table_heder">
          <div class="LR_border" style="width:330px">商品</div>
          <div class="LR_border flex_shrink" style="flexGrow:2">所属商铺</div>
          <div class="LR_border flex_shrink" style="flexGrow:2">订单来源</div>
          <div class="LR_border flex_shrink" style="flexGrow:3">买家信息</div>
          <div class="LR_border flex_shrink" style="flexGrow:4">异常类型</div>
          <div class="LR_border flex_shrink" style="flexGrow:3">买家备注</div>
          <div class="LR_border flex_shrink" style="flexGrow:2">金额合计</div>
          <div class="LR_border flex_shrink" style="flexGrow:1">状态</div>
          <div class="flex_shrink" style="flexGrow:2">操作</div>
        </div>
        <div class="table_content" v-for="(item,index) in tableData" :key="index">
          <div class="info_box">
            <span>订单号:{{item.outTradeNo}}</span>
            <span>申请退款时间：{{item.applyTime}}</span>
          </div>
          <div class="content_box">
            <div class="LR_border" style="width:320px;paddingLeft:10px">
              <div class="info_b" v-for="(itm,idx) in item.vos" :class="[idx!=item.vos.length?'boeder_tline':'']" @click="handleItemIsShow(item)" :key="idx" v-show="idx>0&&item.isCheck?true:idx==0?true:false">
                <img :src="itm.picture" />
                <div class="details_box">
                  <span class="marginB6" style="fontSize:12px">{{itm.commodityName}}</span>
                  <span class="marginB6" style="color:red">￥{{itm.univalent}}</span>
                  <div>
                    <span class="describe">{{itm.specifications}}</span>
                    <span>x{{itm.quantity}}</span>
                  </div>
                </div>
                <div v-show="idx==0&&item.vos.length>1?true:false" @click="item.isCheck=(!item.isCheck)">
                  <span style="color:#1b86f8">{{item.vos.length}}</span>
                  <i class="el-icon-caret-top" v-if="item.isCheck"></i>
                  <i class="el-icon-caret-bottom" v-if="!item.isCheck"></i>
                </div>
              </div>
            </div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:2">
              <span>
                {{item.fullName}}
              </span>
            </div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:2"><span>散户</span></div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:3"><span>{{item.nickName}} {{item.uPhone}}</span></div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:4"><span>{{item.type==1?'退货退款':item.type==2?'退款':item.type==3?'退货':''}}</span></div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:3"><span>{{item.reason}}</span></div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:2;color:red"><span>¥{{item.price}}</span></div>
            <div class="LR_border flex_shrink flex_c" style="flexGrow:1"><span>{{item.state==0?'申请':item.state==1?'申请通过':item.state==2?'申请驳回':item.state==3?'撤销申请':item.state==4?'处理成功':item.state==5?'处理成功' :''}}</span></div>
            <div class="flex_shrink flex_c" style="flexGrow:2">
              <el-button v-if="item.state==0" style="width:90px" type="primary" size="mini" @click="ConfirmShipment(item.id,1)">确认退款</el-button>
              <el-button v-if="item.state==0" style="width:90px;marginTop:6px;marginLeft:0px" type="primary" size="mini" @click="ConfirmShipment(item.id,2)">驳回申请</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialogs v-model="dialogEditVisible" :center='true' title='备注' :HeaderPosition='true' width-dial="350px" :height-dial="100" @dialog="submit">
      <el-input type="textarea" :rows="4" v-model="remarks" style="width:100%" placeholder="-请输入-" />
    </Dialogs>
  </div>
</template>

<script>
// import Pagination from '@/components/pagination/Pagination.vue'
import DateTime from '@/components/DateTime'
import Dialogs from '@/components/DiaLogs'
export default {
  name: 'Refund',
  components: {
    // Pagination,
    DateTime,
    Dialogs
  },
  data() {
    return {
      searchForm: {
        date: null,
        date1: null,
        beginTime: null, //下单开始时间
        endTime: null, //下单结束时间
        outTradeNo: null, //订单号
      },//查询条件
      condition: {
        id: null,
        state: null,
      },
      remarks: null, //备注
      tableData: [],//表格参数
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      dialogEditVisible: false
    };
  },
  computed: {},
  watch: {
    'searchForm.date': {
      handler(val) {
        this.searchForm.beginTime = val[0]
        this.searchForm.endTime = val[1]
      },
      deep: true
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$Refund.handlePage(
        {
          ...this.searchForm,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
           this.tableData.forEach(element => {
            element.isCheck = false
          });
          this.page.total = data.count
        }
      })
    },
    //确认发货
    ConfirmShipment(id, state) {
      if (state == 2) {
        this.remarks = null
        this.condition.id = id
        this.condition.state = state
        this.dialogEditVisible = true
      } else {
        this.$Refund.reviewRefundRequest({ id, state, }).then(({ data }) => {
          if (data.code === 200) {
            this.messages(data.message, true, 1000)
            this.getInfo()
          }
        })
      }
    },
    submit() {
      this.$Refund.reviewRefundRequest({ ...this.condition, remarks: this.remarks }).then(({ data }) => {
        if (data.code === 200) {
          this.messages(data.message, true, 1000)
          this.getInfo()
          this.dialogEditVisible = false
        }
      })
    },
    //导出文件
    exportFile() {
      let { beginTime, endTime, merchantId, state } = this.searchForm
      this.$OrderLIst.orderExport({
        beginTime,
        endTime,
        merchantId,
        state
      }).then((response) => {
        //通过a标签下载
        let url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        console.log(decodeURI(response.headers['content-disposition'].split(';')[1].replace('filename=', '')), 'rrrewwwrssede')
        link.download = decodeURI(response.headers['content-disposition'].split(';')[1].replace('filename=', '')); //获取文件名
        document.body.appendChild(link);
        link.click()
        URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
    handleItemIsShow(item) {
      item.isCheck = item.isCheck ? false : true;
      this.tableData.forEach((EL, index) => {
        if (EL.id == item.id) {
          EL.isCheck = EL.isCheck ? false : true
          let obj = { ...EL }
          this.tableData.splice(index, 1, obj)
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
.table {
  width: 100%;
  .table_heder {
    display: flex;
    box-sizing: border-box;
    height: 48px;
    background: #f8f8fe;
    border: 1px solid #eeeeee;
    margin-bottom: 12px;
    > div {
      width: 100px;
      height: 48px;
      line-height: 48px;
      text-align: center;
    }
  }
  .table_content {
    padding-bottom: 10px;
    .info_box {
      width: 100%;
      height: 30px;
      background: #f4f4f4;
      display: flex;
      > span {
        width: 250px;
        font-size: 12px;
        line-height: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #222222;
      }
    }
    .content_box {
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      display: flex;
      > div {
        width: 100px;
        min-height: 48px;
        text-align: center;
      }
    }
  }
}
.flex_shrink {
  flex-shrink: 1;
}
.LR_border {
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
}
.info_b {
  display: flex;
  box-sizing: border-box;
  height: 88px;
  align-items: center;
  > img {
    width: 55px;
    height: 55px;
  }
  .details_box {
    margin-left: 20px;
    width: 200px;
    display: flex;
    flex-direction: column;
    > span {
      width: 100%;
      text-align: left;
    }
    > div {
      width: 100%;
      display: flex;
      .describe {
        text-align: left;
        width: 100px;
      }
    }
  }
}
.flex_c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.operation_box {
  display: flex;
  align-items: center;
  .margin_right {
    margin-right: 20px;
  }
}
.boeder_tline {
  border-top: 1px solid #eeeeee;
}
.main-min-height{
  min-height: calc(100vh - 74px);
}
</style>
